import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ServiceDetails = () =>
  {
    <>Product Detail will be there!</>
  };

export default ServiceDetails;
